import * as yup from 'yup'

export const staffSchema = yup.object().shape({
email: yup
  .string()
  .trim()
  .email('Invalid email format')
  .required('Email is required')
  .matches(
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    'Enter a valid email address'
  ),  permissions: yup.array(yup.string()).required(),
})

export const passwordSchema = yup.object().shape({
  password: yup
    .string()
    .test(
      'password-match',
      'Password must contain at least 1 letter and 1 number',
      function (value) {
        return /(?=.*\d)(?=.*[a-zA-Z]).{8,}/.test(value || '')
      }
    ),
  confirmPassword: yup
    .string()
    .test('confirm-password', 'Password must match', function (value) {
      return this.parent.password === value
    }),
})

export const twofaCodeSchema = yup.object().shape({
  codeOne: yup.string().matches(/^\d+$/, 'Must be a number').required('Code is required'),
  codeTwo: yup.string().matches(/^\d+$/, 'Must be a number').required('Code is required'),
})

export const twofaCodeLoginSchema = yup.object().shape({
  code: yup.string().matches(/^\d+$/, 'Must be a number').required('Code is required'),
})
